import React, { useState } from "react";
import { Modal, Button, Card } from "antd";
import { ArrowRight, CircleCheck, LucideArrowRight, LucideUserPlus, LucideZap } from "lucide-react";
import HeaderComponent from "components/card/HeaderComponent";
import HeaderModal from "components/modal/HeaderModal";
import EnrolleeDetails from "./EnrolleeDetails";
import ButtonGroup from "antd/es/button/button-group";

const steps = [
  { title: "Select Course" },
  { title: "Select Team Members" },
  { title: "Enroll" },
];

export default function EnrollmentSteps({ 
  step1Done,
  step2Done,
  step3Active,
  selectedCourse,
  selectedMembers }) {
  
  const [isModalOpen, setIsModalOpen] = useState(false);

  const stepStatus = [
    step1Done ? "completed" : !step1Done && !step2Done ? "active" : "inactive",
    step2Done ? "completed" : !step2Done && !step1Done ? "inactive" : !step2Done && step1Done ? "active" : "inactive",
    step3Active ? "active" : "inactive",
  ];

  const handleStepClick = (index) => {
      if (index === 2 && step3Active) {
        setIsModalOpen(true);
      }
    };
    
 return (
    <>
      <div className="stepper-container flex items-center gap-4">
        {steps.map((step, index) => (
          <div key={index} className="step-wrapper flex items-center gap-2">
            <div
              className={`step-box ${stepStatus[index]} cursor-pointer`}
              onClick={() => handleStepClick(index)}
            >
              <div className="step-circle flex items-center justify-center w-6 h-6 rounded-full bg-gray-200">
                {stepStatus[index] === "completed" ? (
                  <CircleCheck className="w-4 h-4 text-white" />
                ) : (
                  index + 1
                )}
              </div>
              <span className="step-label ml-2">{step.title}</span>
            </div>

            {index < steps.length - 1 && <ArrowRight size={20} className="text-white"/>}
          </div>
        ))}
      </div>
      <div className="">
        <HeaderModal
          group="gradient-icon"
          open={isModalOpen}              
          onClose={() => setIsModalOpen(false)}
          icon={<LucideZap size={32} className="text-white"/>}
          closable={false}                     
          title={"Ready to Enroll!"}                    
          description={"Review the enrollment details below and confirm to proceed."}             
          colorTheme="gradient-emerald"
          footer={(
              <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end relative m-4">
                <button onClick={() => setIsModalOpen(false)} className="border-2 border-slate-100 rounded-xl px-2">Cancel</button>
                <button type="button" className="btn-gradient-emerald p-2 flex">
                  {<div className="flex items-center gap-2">
                      {<LucideUserPlus size={16} className="flex"/>} Confirm Enrollment <LucideArrowRight size={16} className="flex"/>
                  </div>}
                </button>
              </div>
            )}  
          >
            <EnrolleeDetails
              selectedCourse={selectedCourse}
              selectedMembers={selectedMembers}
            />
        </HeaderModal>
      </div>
        
    </>
  );
}
